import { createReducer } from "reduxsauce";

import ReducerRegister from "../../ReducerRegister";
import RegisterService from "../../../services/screens/account/RegisterService";
import { ActionTypes } from "../../actionTypes/screens/account/RegisterActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";

import UIDs from "../../../UIDs";

const uid = UIDs.screens.account.register;

//
// Actions
//
const Actions = {
    registerAsync: (firstName, lastName, email, password) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REGISTER_ASYNC, firstName, lastName, email, password });

            RegisterService.register(
                firstName,
                lastName,
                email,
                password,
                response => {
                    dispatch(Actions.registerSuccess(response));
                },
                error => {
                    dispatch(Actions.registerFailure(error));
                }
            );
        };
    },

    registerSuccess: data => ({
        type: ActionTypes.REGISTER_SUCCESS,
        parentType: ActionTypes.REGISTER_ASYNC,
        data
    }),

    registerFailure: error => ({
        type: ActionTypes.REGISTER_FAILURE,
        parentType: ActionTypes.REGISTER_ASYNC,
        error
    })
};

//
// Initial State
//
const INITIAL_STATE = {

};

//
// Reducers
//


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.REGISTER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REGISTER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REGISTER_FAILURE]: AsyncActionReducers.failureReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
